import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { usePagination } from '@material-ui/lab';

import styles from 'assets/jss/material-dashboard-pro-react/components/paginationStyle';

const useStyles = makeStyles(styles);

export default function Pagination(props) {
	const classes = useStyles();
	const { items } = usePagination({
		...props
	});

	return (
		<nav className={classes.root}>
			<ul className={classes.pagination}>
				{items.map(({ page, type, selected, ...item }, index) => {
					const paginationLink = cx({
						[classes.paginationLink]: true,
						[classes.primary]: selected,
						[classes.disabled]: props.disabled
					});

					let children = null;

					if (type === 'start-ellipsis' || type === 'end-ellipsis') {
						children = <div className={paginationLink}>…</div>;
					} else if (type === 'page') {
						children = (
							<button type='button' className={paginationLink} style={{ fontWeight: selected ? 'bold' : undefined }} {...item}>
								{page}
							</button>
						);
					} else {
						children = (
							<button type='button' className={paginationLink} {...item}>
								{type === 'next' ? 'next' : 'prev'}
							</button>
						);
					}
					return <li key={index} className={classes.paginationItem}>{children}</li>;
				})}
			</ul>
		</nav>
	);
}

Pagination.defaultProps = {
	defaultPage: 0
};

Pagination.propTypes = {
	count: PropTypes.number,
	defaultPage: PropTypes.number,
	siblingCount: PropTypes.number,
	onChange: PropTypes.func
};
